import React from 'react'
import _ from 'lodash'
import { useTheme } from '@material-ui/styles'
import { Typography } from '@material-ui/core'

export default ({ boolean, text, showFalse = true }) => {
  const theme = useTheme()

  if (!_.isBoolean(boolean)) return null
  if (showFalse === false && boolean === false) return null

  const renderBool = () => {
    if (boolean === false) {
      return <strong style={{ color: theme.palette.primary.green }}>Não</strong>
    }

    return <strong style={{ color: theme.palette.primary.red }}>Sim</strong>
  }

  return (
    <Typography>
      {text}
      {': '}
      {renderBool()}
    </Typography>
  )
}
